export const SUPPORTS_ARRAY_PROTOTYPE_FLAT = "flat" in Array.prototype;
